<div class="user-mgt-container">
  @if (isLoggedIn()) {
  <span class="welcome">Welcome {{getUser()}}</span>
  }
  <button mat-mini-fab [matMenuTriggerFor]="userMenu" color="primary" #menuTrigger>
    <mat-icon fontIcon="account_circle"></mat-icon>
  </button>
  
  <mat-menu #userMenu="matMenu">
    @if (isLoggedIn()) {
    <button mat-menu-item class="menu-item" (click)="logout()">
      <span class="menu-item">Logout</span>
    </button>
    }
    @else {
    <button mat-menu-item class="menu-item" (click)="login()">
      <span class="menu-item">Login</span>
    </button>
    }
    @if(isAdmin()){
    <button mat-menu-item class="menu-item" (click)="clearLog()">
      <span class="menu-item">Clear Log</span>
    </button>
    }
  </mat-menu>
</div>